
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  width:100%;
}

.placeholder-wrapper{
  display:flex;
  align-items:center;
  justify-content:center;
  width:100%;
  min-height:200px;
  background-color:#f3f4f6;
  background-color:var(--color-neutral-100, #f3f4f6);
  border:1px solid #e5e7eb;
  border:1px solid var(--color-neutral-200, #e5e7eb);
  border-radius:4px;
}

.placeholder-content{
  text-align:center;
  padding:2rem;
  max-width:400px;
}

.placeholder-message{
  margin:0 0 1rem;
  color:#4b5563;
  color:var(--color-neutral-600, #4b5563);
  font-size:1rem;
  line-height:1.5;
}

.placeholder-button{
  display:inline-block;
  padding:0.5rem 1.25rem;
  background-color:#004ea8;
  background-color:var(--color-primary-default, #004ea8);
  color:#ffffff;
  border:none;
  border-radius:4px;
  font-size:0.9rem;
  font-weight:600;
  cursor:pointer;
  transition:background-color 0.2s ease;
}

.placeholder-button:hover{
  background-color:#003c82;
  background-color:var(--color-primary-dark, #003c82);
}

.placeholder-button:focus-visible{
  outline:2px solid #004ea8;
  outline:2px solid var(--color-primary-default, #004ea8);
  outline-offset:2px;
}
`;